import request from '../../utils/request'
const urlParams = process.env.VUE_APP_UPLOAD_REAL_PATH
export default {
  // 获取浙里办工单列表
  zlbOderWorkList(data) {
    const params = data
    return request({
      url: urlParams + '/zlb-order-work/list',
      type: 'get',
      params: params
    })
  },    
  // 获取浙里办建议咨询管理
  zlbAdviceList(data) { 
    const params = data
    return request({
      url: urlParams + '/zlb-advice/list',
      type: 'get',
      params: params
    })
  },  
  // 获取浙里办访客管理
  zlbVisitorList(data) {
    const params = data
    return request({
      url: urlParams + '/zlb-visitor/list',
      type: 'get',
      params: params
    })
  },    
}